import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useStore } from 'react-redux';
import { getActiveBrandAppIcon, useSession } from '../../../../../../infra/session';
import { PushCampaignPreview } from './push-campaign-preview';
import { initializePushContent } from '../../campaign-content/push-content/initialize';
export var PushCampaignPreviewContainer = function (_a) {
    var campaignPushBody = _a.campaignPushBody, campaignPushTitle = _a.campaignPushTitle, isLoading = _a.isLoading;
    var store = useStore();
    var session = useSession().data;
    var logo = getActiveBrandAppIcon(session);
    useEffect(function () {
        initializePushContent({ store: store });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return (_jsx(PushCampaignPreview, { logoImage: logo, title: campaignPushTitle, body: campaignPushBody, isLoading: isLoading }));
};
